(function () {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoFacultadController', SSProyectoFacultadController);

    SSProyectoFacultadController.$inject = ['$state', 'SSProyecto', 'periodos', 'programasEducativos', 'estatusProyectos', 'ParseLinks', 'AlertService'];

    function SSProyectoFacultadController($state, SSProyecto, periodos, programasEducativos, estatusProyectos, ParseLinks, AlertService) {

        var vm = this;
        vm.searchForm = {};
        vm.search = search;
        vm.searchType = "filters";

        vm.proyectoAccion = proyectoAccion;
        vm.proyectoDetalleAsignacion = proyectoDetalleAsignacion;
        vm.proyectoDetalleSolicitud = proyectoDetalleSolicitud;

        periodos.$promise.then(function (periodos) {
            vm.periodos = periodos;
            vm.selectedPeriodo = periodos[0];
        });

        vm.estatusProyecto = estatusProyectos;
        vm.selectedEstatusProyecto = estatusProyectos[0];

        programasEducativos.$promise.then(function (programasEducativos) {
            vm.programasEducativos = angular.copy(programasEducativos);
            vm.programasEducativos.unshift({ id: 0, nombre: '- Todos', centroDocente: { id: 0 } });
            console.log(vm.programasEducativos);
            vm.selectedProgramaEducativo = vm.programasEducativos[0];
            loadProyectos();
        });

        function search() {
            if (vm.searchType == "filters") {
                loadProyectos();
            } else if (vm.searchType == "student" && !(vm.alumno == null || vm.alumno == "")) {
                loadAlumno();
            } else {
                vm.sSProyectos = [];
            }
        }

        function loadAlumno() {
            SSProyecto.queryAlumnoFacultad({
                alumno: vm.alumno
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });
        }

        function loadProyectos() {
            SSProyecto.queryCurrentUser({
                idCentroDocente: vm.selectedProgramaEducativo.centroDocente.id,
                idProgramaEducativo: vm.selectedProgramaEducativo.id,
                fechaIniPer: vm.selectedPeriodo.iniPeriodo,
                fechaFinPer: vm.selectedPeriodo.finPeriodo,
                estatusProyecto: vm.selectedEstatusProyecto
            }).$promise.then(function (proyectos) {
                vm.sSProyectos = proyectos;
            });

        }

        function proyectoDetalleAsignacion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoAccion(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-detail', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoDetalleSolicitud(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-solicitud', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }

        function proyectoSeguimiento(idProyecto, propagation, $event) {
            $state.go('ss-proyecto-facultad-seguimiento', { id: idProyecto });
            if (propagation == false) {
                $event.stopPropagation();
            }
        }
    }
})();
